// Microsoft Entra / Azure AD OAuth2 Configuration for Harmonee Pulse
export const MS_CLIENT_ID = '10b3cf95-396d-4131-b71e-3359c2575288';

export const MS_AUTHORITY = 'https://login.microsoftonline.com/common';

export const MS_SCOPES = [
  'User.Read',
  'Mail.Read',
  'Mail.ReadWrite',
  'Mail.Send',
  'Calendars.Read',
  'Calendars.ReadWrite',
  'Calendars.Read.Shared',
  'Calendars.ReadWrite.Shared',
  'Files.Read',
  'Files.Read.All',
];

export const MS_REDIRECT_URI = window.location.origin;
